import { put } from 'redux-saga/effects';
import axios from '../../../utils/axios';
import { BASEURL } from '../../../BaseUrl/BaseUrl';
import {
  startFormLoading,
  stopFormLoading,
  hasError,
  getErrorMessage,
  getSuccessMessage,
  setResponse,
} from '../../slices/responseStatus';
import { getLabelingData } from '../../slices/labelingSlice';

export function* getLabelingSaga() {
  try {
    yield put(startFormLoading());
    const token = window.localStorage.getItem('auth-token');
    const response = yield axios.get(`${BASEURL}/companies/labeling`, {
      headers: {
        'x-auth-token': `${token}`,
      },
    });
    yield put(getLabelingData(response?.data?.data?.labels || {}));
    yield put(stopFormLoading());
  } catch (error) {
    yield put(stopFormLoading());
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* editLabelingSaga(action) {
  try {
    yield put(startFormLoading());
    const token = window.localStorage.getItem('auth-token');
    const newData = {
      labels: action.data,
    };
    const response = yield axios.put(`${BASEURL}/companies/labeling`, newData, {
      headers: {
        'x-auth-token': `${token}`,
      },
    });
    const labels = response.data?.data?.labels || {};
    if (response.status === 200) {
      yield put(getSuccessMessage(response.data.meta.message));
      yield put(setResponse(response.status));
      yield put(getLabelingData(action.data));
    }
    yield put(stopFormLoading());
  } catch (error) {
    yield put(stopFormLoading());
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}
